export default function XML_Parser() {
  return (
    <div>
      <h1>XML_Parser</h1>
      <p>This is the XML_Parser component.</p>
    </div>
  );
}